import { render, staticRenderFns } from "./DepartmentAuthSelector.vue?vue&type=template&id=43ce2954&scoped=true&"
import script from "./DepartmentAuthSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentAuthSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentAuthSelector.vue?vue&type=style&index=0&id=43ce2954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ce2954",
  null
  
)

export default component.exports